import { parseManualImageJob } from "./settings-protocol";
import type { ManualImagePublicJob } from "./types";

export const IMAGE_JOB_QUEUE_POLL_INTERVAL_MS = 5_000;
export const IMAGE_JOB_QUEUE_MAX_POLL_ATTEMPTS = 120;
export const IMAGE_JOB_QUEUE_HISTORY_MS = 7 * 24 * 60 * 60 * 1_000;
export const IMAGE_JOB_QUEUE_POLL_CONCURRENCY = 4;

export interface ImageJobQueuePage {
  jobs: ManualImagePublicJob[];
  next_cursor: string | null;
}

function record(value: unknown): Record<string, unknown> {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("image_job_queue_response_invalid");
  return value as Record<string, unknown>;
}

export function parseImageJobQueuePage(value: unknown): ImageJobQueuePage {
  const page = record(value);
  if (!Array.isArray(page.jobs)) throw new Error("image_job_queue_response_invalid");
  let nextCursor: string | null;
  if (page.next_cursor === null) nextCursor = null;
  else if (typeof page.next_cursor === "string" && /^\d{1,16}\.[0-9a-f-]{36}$/i.test(page.next_cursor) && page.next_cursor.length <= 64) nextCursor = page.next_cursor;
  else throw new Error("image_job_queue_response_invalid");
  try {
    return { jobs: page.jobs.map(parseManualImageJob), next_cursor: nextCursor };
  } catch {
    throw new Error("image_job_queue_response_invalid");
  }
}

export function imageJobQueueUrl(cursor?: string): string {
  const params = new URLSearchParams({ limit: "100" });
  if (cursor && /^\d{1,16}\.[0-9a-f-]{36}$/i.test(cursor) && cursor.length <= 64) params.set("cursor", cursor);
  return `/v1/discord-settings/image/jobs?${params}`;
}

export function isImageJobQueueItemActive(job: ManualImagePublicJob): boolean {
  return job.status === "queued" || job.status === "claimed" || job.status === "generated" || job.status === "outcome_unknown";
}

export function imageJobQueueSource(job: ManualImagePublicJob): ManualImagePublicJob["source"] {
  return job.source;
}
